module.exports = __webpack_public_path__ + "img/2016_1.f326b98c.webp";